import React from "react";
import { ShadowCard } from "../ShadowCard/ShadowCard";
import { useMediaQuery } from "react-responsive";
import {
  _1200px,
  _1400px,
  _1500px,
  _1600px,
  _1700px,
  _1800px,
  _576px,
  _768px,
  _992px,
} from "../../utils/mediaBreakpoints";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { useNavigate } from "react-router-dom";

const ShadowCardContainer = ({ isMobile, cards }) => {
  const _576 = useMediaQuery({ maxWidth: _576px });
  const _768 = useMediaQuery({ maxWidth: _768px });
  const _992 = useMediaQuery({ maxWidth: _992px });
  const _1200 = useMediaQuery({ maxWidth: _1200px });
  const _1400 = useMediaQuery({ maxWidth: _1400px });
  const _1500 = useMediaQuery({ maxWidth: _1500px });
  const _1600 = useMediaQuery({ maxWidth: _1600px });
  const _1700 = useMediaQuery({ maxWidth: _1700px });
  const _1800 = useMediaQuery({ maxWidth: _1800px });
  const navigate = useNavigate();

  const responsive = {
    desktop: {
      breakpoint: { max: 3000, min: 1200 },
      items: 3,
      partialVisibilityGutter: 55,
    },
    tab: {
      breakpoint: { max: 1240, min: 768 },
      items: 2,
      partialVisibilityGutter: 55,
    },
    mobile: {
      breakpoint: { max: 768, min: 576 },
      items: 1,
      partialVisibilityGutter: 120,
    },
    sx: {
      breakpoint: { max: 576, min: 0 },
      items: 1,
      // partialVisibilityGutter: ,
    },
  };
  return (
    <>
      {/* <div
          className="container-fluid m-0 p-0"
          style={{
            height: "100vh",
            background:
              "linear-gradient(to bottom, #1F46BE 0%, #1F46BE 32%, #090D24 32%, #090D24 100%)",
          }}
        >
          <div
            className="container px-0 contwidth"
            style={{ padding: "5rem 0" }}
          >
            <div
              className="row flex-nowrap overflow-auto"
              style={{
                padding: isMobile ? "0 1rem" : "0",
                zIndex:1,
              }}
            >
              {cards?.map((card, index) => (
                <div
                  key={index}
                  className="col-12 col-md-4"
                  style={{
                    flex: "0 0 auto", // very important for scroll
                    minWidth: "300px", // set card width here
                  }}
                >
                  <ShadowCard
                    isCrdWhite={true}
                    topHeading={card?.heading}
                    text={card?.sub_heading}
                    topIcon={card?.top_icon?.url}
                    lineColor={card?.horizontal_line_color}
                    headingClass={"fw800 fs35"}
                    textClass={"fw400 fs20"}
                    topIConHeight={card?.top_icon?.height}
                    topIConWidth={card?.top_icon?.width}
                  />
                </div>
              ))}
            </div>
          </div>
        </div> */}
      <div
        className="container-fluid m-0"
        style={{
          height: "max-content",
          background:
            "linear-gradient(to bottom, #1F46BE 0%, #1F46BE 32%, #090D24 32%, #090D24 100%)",
        }}
      >
        <div
          style={{
            paddingTop: "3.5rem",
            paddingBottom: "3.5rem",
            paddingLeft: _768
              ? ""
              : _992
                ? "1.3rem"
                : _1200
                  ? "5rem"
                  : _1400
                    ? "7rem"
                    : _1500
                      ? "7.6rem"
                      : _1600
                        ? "8rem"
                        : _1700
                          ? "8.5rem"
                          : _1800
                            ? "9.3rem"
                            : "10rem",
          }}
        >
          <Carousel
            responsive={responsive}
            partialVisible={true}
            // infinite={true}
            // autoPlay={true}
            // autoPlaySpeed={1800}
            keyBoardControl={true}
            showDots={false}
            arrows={true}
            swipeable={true}
            draggable={true}
            customTransition="all .5s ease"
            transitionDuration={500}
            containerClass="ps-md-3 py-custom pt-5 d-flex "
            itemClass={`d-flex crd ${_768 ? "justify-content-center" : ""}`}
          >
            {cards?.map((card, index) => (
              <div
                onClick={() => navigate(card?.link)}
                className={`cursor-pointer px-4 px-md-0 ps-md-0 d-flex ${_768 ? "justify-content-center" : ""
                  } `}
                key={index}
                style={{
                  width: "100%",
                  // _576
                  //   ? "100%"
                  //   : _768
                  //   ? "100%"
                  //   : _1200
                  //   ? "320px"
                  //   : _1400
                  //   ? "320px"
                  //   : _1500
                  //   ? "345px"
                  //   : _1700
                  //   ? "360px"
                  //   : _1800
                  //   ? "428px"
                  //   : "464px",
                  height: _576
                    ? "365px"
                    : _768
                      ? "360px"
                      : _1200
                        ? "365px"
                        : _1400
                          ? "365px"
                          : _1600
                            ? "365px"
                            : _1700
                              ? "420px"
                              : _1800
                                ? "410px"
                                : "410px",
                }}
              >
                <ShadowCard
                  isCrdWhite={true}
                  topHeading={card?.heading}
                  text={card?.sub_heading}
                  topIcon={card?.top_icon?.url}
                  lineColor={card?.horizontal_line_color}
                  textClass={`fw400 ${_576
                      ? "fs16"
                      : _768
                        ? "fs20"
                        : _992
                          ? "fs16"
                          : _1200
                            ? "fs16"
                            : _1400
                              ? "fs16"
                              : _1500
                                ? "fs16"
                                : _1600
                                  ? "fs16"
                                  : _1700
                                    ? "fs18"
                                    : _1800
                                      ? "fs18"
                                      : "fs20"
                    }`}
                  headingClass={`fw800 ${_576
                      ? "fs20"
                      : _768
                        ? "fs25"
                        : _992
                          ? "fs25"
                          : _1200
                            ? "fs25"
                            : _1400
                              ? "fs24"
                              : _1500
                                ? "fs28"
                                : _1600
                                  ? "fs28"
                                  : _1700
                                    ? "fs32"
                                    : _1800
                                      ? "fs35"
                                      : "fs35"
                    } `}
                  topIConHeight={card?.top_icon?.height}
                  topIConWidth={card?.top_icon?.width}
                />
              </div>
            ))}
          </Carousel>
        </div>
      </div>
    </>
  );
};

export default ShadowCardContainer;
